import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { EntityMappingsFilterBuilder } from '../components/filters/adapters/EntityMappingsFilterBuilder';
import { FlexibleFilter } from '../components/filters/flexible/flexible-filter-types';

export const FilterBuilderTest: React.FC = () => {
  const [filters, setFilters] = useState<FlexibleFilter[]>([]);
  const [validation, setValidation] = useState<boolean>(true);

  return (
    <div className="min-h-screen bg-background">
      <div className="w-full py-8 px-6">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-center mb-2">Filter Builder Test</h1>
          <p className="text-center text-muted-foreground">
            Real Dataverse integration with improved search interface
          </p>
        </div>
        
        <Card className="mb-6">
          <CardHeader>
            <CardTitle>Dataverse Filter Builder</CardTitle>
            <p className="text-sm text-muted-foreground">
              Uses actual Dataverse entities and fields with search-as-you-type functionality
            </p>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <strong>Active Filters:</strong> {filters.length}
              </div>
              <div>
                <strong>Validation Status:</strong> 
                <span className={validation ? 'text-green-600 ml-2' : 'text-red-600 ml-2'}>
                  {validation ? '✓ Valid' : '✗ Invalid'}
                </span>
              </div>
            </div>
          </CardContent>
        </Card>
        
        <EntityMappingsFilterBuilder
          onFiltersChange={setFilters}
          onValidationChange={setValidation}
          initialFilters={filters}
        />
        
        {filters.length > 0 && (
          <Card className="mt-8">
            <CardHeader>
              <CardTitle>Generated Filters</CardTitle>
            </CardHeader>
            <CardContent>
              <pre className="bg-muted p-4 rounded text-sm overflow-auto max-h-60">
                {JSON.stringify(filters, null, 2)}
              </pre>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
};
